module.exports = __webpack_public_path__ + "static/media/dot-circle-regular.b878ce33.svg";